import { computed } from '@ember/object';
import LogoUpload from './mixins/logo-upload';
import { sanitizeHtml } from '@intercom/pulse/lib/sanitize';
import { normalizeEvent } from '@intercom/embercom-composer/lib/normalize-event';
import $ from 'jquery';
import { alias, and, equal, not, or } from '@ember/object/computed';
import { bind, scheduleOnce, next } from '@ember/runloop';
import Em from 'ember';
export default Em.Component.extend(LogoUpload, {
  widgetHtml: '',
  classNames: ['widget-component'],
  classNameBindings: ['selected:customisable-widget-selected', 'isReadOnly:widget-component-readonly', 'isReadOnlyAndInvalid:composer-is-hidden', 'editingStateClass'],
  attributeBindings: ['data-widget-name'],
  'data-widget-name': alias('widget.name'),
  editingState: 'initial',
  isReadOnlyAndInvalid: and('isReadOnly', 'isInvalid'),
  isInvalid: not('isValid'),
  editingStateClass: computed('editingState', function () {
    return `customisable-widget-${this.editingState}`;
  }),
  selected: and('popoverOrEditorVisible', 'isValid'),
  popoverOrEditorVisible: or('popoverVisible', 'editorVisible'),
  popoverVisible: equal('editingState', 'popover'),
  warningVisible: equal('editingState', 'warning'),
  editorVisible: equal('editingState', 'editing'),
  actionToBeConfirmed: null,
  init() {
    this._super();
    if (this.get('widget.template')) {
      this.set('widgetTemplate', this.get('widget.template'));
    } else if (this.get('widget.html') && Handlebars) {
      // This should only ever fire in dev, handlebars compiler is not available in prod
      this.set('widgetTemplate', Handlebars.compile(this.get('widget.html')));
    } else {
      throw new Error('must specify a widget template');
    }
  },
  didInsertElement() {
    this._super(...arguments);
    $(document).on(`click.background-${this.get('elementId')}`, bind(this, this._bodyClickHandler));
    $(document).on(`keydown.${this.get('elementId')}`, bind(this, this._keyDownHandler));
    this.renderWidget();
  },
  willDestroyElement() {
    this._super(...arguments);
    $(document).off(`click.background-${this.get('elementId')}`);
    $(document).off(`keydown.${this.get('elementId')}`);
  },
  _bodyClickHandler(e) {
    let $target = $(e.target);
    let $this = $(this.element);
    if ($target[0] !== $this[0] && !$.contains($this[0], $target[0]) && this.get('editingState') === 'popover') {
      this.setEditingState('initial');
      this.renderWidget();
    }
  },
  _keyDownHandler(e) {
    if (this.get('editingState') === 'popover') {
      if (this.isDeleteOrBackspace(e)) {
        this.set('actionToBeConfirmed', 'delete');
        this.setEditingState('warning');
      }
      e.preventDefault();
    }
  },
  isDeleteOrBackspace(e) {
    return e.which === 8 || e.which === 46;
  },
  deleteRequiredFields() {
    let requiredFields = this.get('widget.requiredFields');
    requiredFields.split('|').forEach(this.deleteField, this);
  },
  deleteField(fieldName) {
    let datum = this.get('emailTemplateData').findBy('identifier', fieldName);
    if (datum) {
      datum.set('value', '');
      this.send('notifyChange', fieldName, '');
    }
  },
  renderWidget() {
    let widgetHtml = this.get('widgetTemplate')(this.get('templateContext'));
    this.set('widgetHtml', widgetHtml);
    scheduleOnce('afterRender', this, this.setSelectionCoordinatesForEditor);
  },
  templateContext: Em.computed('emailTemplateData.@each.value', 'isValid', function () {
    let context = {};
    this.get('emailTemplateData').forEach(function (datum) {
      context[datum.get('identifier')] = datum.get('value');
    });
    context.hasSocial = !!(context.facebook || context.twitter);
    return context;
  }),
  widgetHtmlSafe: Em.computed('widgetHtml', function () {
    return sanitizeHtml(this.get('widgetHtml'));
  }),
  isValid: Em.computed('emailTemplateData.@each.value', function () {
    let valid = false;
    let requiredFields = this.get('widget.requiredFields');
    requiredFields.split('|').forEach(function (field) {
      if (!valid) {
        let datum = this.get('emailTemplateData').findBy('identifier', field);
        if (datum) {
          valid = !!datum.get('value');
        }
      }
    }.bind(this));
    return valid;
  }),
  isValidOrReadOnlyDidChange: Em.observer({
    dependentKeys: ['isValid', 'isReadOnly'],
    fn() {
      this.renderWidget();
    },
    sync: true
  }),
  launchEditor() {
    let editor = this.get('widget.editor');
    if (editor === 'logo') {
      this.fileUpload();
    } else {
      this.setSelectionCoordinatesForEditor();
      this.set('activeEditor', `customisable-widget-editor-${editor}`);
      this.setEditingState('editing');
    }
  },
  showPopover() {
    this.setSelectionCoordinatesForEditor();
    this.setEditingState('popover');
  },
  setSelectionCoordinatesForEditor() {
    this.set('selectionCoordinates', {
      top: 0,
      left: 0,
      width: $(this.element).outerWidth()
    });
  },
  click(e) {
    let isModalOk = $(e.target).hasClass('js__intercom-confirm-button');
    let isInput = $(e.target).is('input');
    if (!isInput && !isModalOk && !this.get('isReadOnly') && this.get('isValid') && !(this.get('editorVisible') || this.get('popoverVisible'))) {
      this.showPopover();
    }
    this.get('editorView').clearSelection();
  },
  change(event) {
    let nativeEvent = normalizeEvent(event);
    if (nativeEvent) {
      let target = nativeEvent.target;
      if ($(target).is('.composer-file-upload')) {
        this.fileuploadChanged(target);
      }
    }
  },
  fileUpload() {
    let $fileInput = $('.composer-file-upload', this.element);
    $fileInput.val(null);
    $fileInput.trigger('click');
  },
  fileuploadChanged(element) {
    this.uploadLogo(element.files[0]);
  },
  setEditingState(state) {
    next(this, function () {
      this.set('editingState', state);
    });
  },
  focusOkButton: Em.observer({
    dependentKeys: ['warningVisible'],
    fn() {
      if (this.get('warningVisible')) {
        scheduleOnce('afterRender', this, function () {
          $('.js__intercom-confirm-button', this.element).focus();
        });
      }
    },
    sync: true
  }),
  ensureEmailTemplateDataIsAvailableForWidget() {
    let emailTemplateData = this.get('emailTemplateData');
    this.get('widget.requiredFields').split('|').forEach(identifier => {
      let datum = this.get('emailTemplateData').findBy('identifier', identifier);
      if (!datum) {
        datum = Em.Object.create({
          identifier,
          value: ''
        });
        emailTemplateData.pushObject(datum);
      }
    });
  },
  deleteWidget() {
    this.deleteRequiredFields();
    this.setEditingState('initial');
    this.set('actionToBeConfirmed', null);
  },
  actions: {
    confirmAction() {
      if (this.get('actionToBeConfirmed') === 'delete') {
        this.deleteWidget();
      } else {
        this.send('openEditor');
      }
    },
    openEditor() {
      this.ensureEmailTemplateDataIsAvailableForWidget();
      next(this, function () {
        this.launchEditor();
      });
    },
    showWarningDialog() {
      this.setEditingState('warning');
    },
    hideWarningDialog() {
      this.setEditingState('popover');
    },
    closeEditor(changes) {
      this.setEditingState('initial');
      changes.forEach(change => {
        this.send('notifyChange', change.identifier, change.value);
      });
    },
    notifyChange(identifier, value) {
      this.emailTemplateDataDidChange?.(identifier, value);
    }
  }
});